export enum NotificationLocalStorageKeys {
  lastCreatedVersion = 'NOTIFICATION_LAST_CREATED_VERSION',
}
